import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import SearchResults from './pages/SearchResults';
import './styles/components.css';
import { StatsProvider } from './contexts/StatsContext';

function App() {
  return (
    <StatsProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/search" element={<SearchResults />} />
        </Routes>
      </Router>
    </StatsProvider>
  );
}

export default App; 